<div>
  <video id="videoBkg" poster="https://www.sicontis.com/codepen/cpc-spacing/ski.png" preload autoplay muted loop>
    <source src="https://www.sicontis.com/codepen/cpc-spacing/skiing.mp4" type="video/mp4">
  </video>
  
  <div class="hero-section">
    <h1>viaja.</h1>
    <h1>crece.</h1>
    <h1>crea.</h1>
    <p>¿Quieres vivir en España? <br>Somos <strong>VoyJaleas</strong> y podemos ayudarte a conseguir tu meta.</p>
  
    <button>Reservar videollamada gratuita</button>
  </div>
  
  <div class="menu-section">
    <p>Queenstown<span>Life</span></p>
    <ul>
      <li>About</li>
      <li>Deals</li>
      <li>Blog</li>
      <li>Contact</li>
    </ul>
  </div>
</div>